// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1co9S","col":"styles_col__1AJgb"};